/**
 * 指定した西暦年の 12 月 31 日時点の満年齢（所得税の年齢入力の簡易代替）
 */
export function ageAtYearEnd(対象年: number, 生年: number, 生月: number, 生日: number): number {
  const yearEnd = new Date(対象年, 11, 31);
  const birth = new Date(生年, 生月 - 1, 生日);
  if (birth.getTime() > yearEnd.getTime()) return -1;
  let age = 対象年 - 生年;
  const birthdayThisYear = new Date(対象年, 生月 - 1, 生日);
  if (yearEnd < birthdayThisYear) age--;
  return age;
}
